var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"snackbar"},[_c('transition',{attrs:{"name":"snackfade"}},[(_vm.snackbar && (_vm.$store.state.isAdmin || _vm.snackbar.public))?_c('div',{staticClass:"snack",class:'has-text-' + _vm.snackbar.color,domProps:{"innerHTML":_vm._s(_vm.html)}}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }